import { Combobox, ComboboxItem, Input, InputBase, ScrollArea, useCombobox } from '@mantine/core';
import { FC, ReactNode } from 'react';

interface Props {
    label: string;
    search: string;
    setSearch: (search: string) => void;
    setValue: (value: string) => void;
    options: ComboboxItem[];
    leftSection?: ReactNode;
    disabled?: boolean;
    placeholder?: string;
    notFoundMessage?: string;
}

const CustomSearchableSelect: FC<Props> = ({
    label,
    search,
    setSearch,
    setValue,
    options,
    leftSection,
    disabled = false,
    placeholder,
    notFoundMessage = 'Nichts gefunden',
}) => {
    const combobox = useCombobox();

    const handleSelect = (item: ComboboxItem): void => {
        setValue(item.value);
        setSearch(item.label);
    };

    return (
        <Combobox
            store={combobox}
            onOptionSubmit={(val) => {
                setValue(val);
                combobox.closeDropdown();
            }}
        >
            <Combobox.Target>
                <InputBase
                    label={label}
                    placeholder={placeholder}
                    value={search}
                    onChange={(event) => {
                        setSearch(event.currentTarget.value);
                        combobox.openDropdown();
                    }}
                    leftSection={leftSection}
                    rightSection={
                        search === '' ? undefined : (
                            <Input.ClearButton
                                onClick={() => {
                                    setSearch('');
                                    setValue('');
                                }}
                            />
                        )
                    }
                    rightSectionPointerEvents="auto"
                    disabled={disabled}
                />
            </Combobox.Target>

            <Combobox.Dropdown>
                <ScrollArea.Autosize className="max-h-40">
                    {options.length === 0 ? (
                        <div className="p-lg text-dimmed m-3 flex items-center justify-center">{notFoundMessage}</div>
                    ) : (
                        options.map((item) => (
                            <Combobox.Option
                                key={item.value}
                                value={item.value}
                                onMouseDown={() => handleSelect(item)} // use onMouseDown to avoid blur-before-select
                            >
                                {item.label}
                            </Combobox.Option>
                        ))
                    )}
                </ScrollArea.Autosize>
            </Combobox.Dropdown>
        </Combobox>
    );
};

export default CustomSearchableSelect;
